module.exports = __webpack_public_path__ + "img/OPI-Banner-05.cb78abee.jpg";